<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
		[ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<section class="main-side-nav"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
	<section class="container delegate-home-page-container">
		<section class="template-section-title">
			<div class="title-container">
				<h1>Delegate Home Page</h1>
			</div>
		</section>
		<section class="no-items">

			<ng-container>
				<div class="desktop-explanation dynamic-explanation"
					[ngClass]="statusDelegateExplanations ? 'explanationDesktopCollapsed' : '' ">
					<div class="container">
						<div class="closing-help-btn"
							(click)="statusDelegateExplanations = !statusDelegateExplanations">
							<img alt="closing help button" src="../../assets/img/{{themeService.theme}}/close-btn1.svg">
						</div>
						<img src="../../assets/img/{{themeService.theme}}/how-works.svg" alt="Section Logo"
							width="170px">
						<div class="title">What is a delegate?</div>
						<p>
							Congratulations on being made a delegate! This means someone close to you has chosen to
							share
							their Zenplan with you.
						</p>
						<p>
							As a Delegate, you can access a Zenplan according to the permission level that you have been
							granted by its owner. Head over to your Shared Plans menu to see the Zenplans that have been
							shared with you.
						</p>
						<p>
							As a delegate, you can access a plan according to the permission level that you have been
							granted
							by the plan owner. Head over to your Shared Plans menu to see the plans that have been
							shared
							with you.
						</p>
					</div>
				</div>

				<div class="mobile-explanation dynamic-explanation"
					[ngClass]="statusDelegateExplanations ? 'explanationMobileCollapsed' : '' ">
					<div class="container">
						<div class="closing-help-btn"
							(click)="statusDelegateExplanations = !statusDelegateExplanations">
							<img alt="closing help button" src="../../assets/img/{{themeService.theme}}/close-btn1.svg">
						</div>
						<app-delegate-home-mobile-explanation></app-delegate-home-mobile-explanation>
					</div>
				</div>
			</ng-container>
			<ng-container>
				<div class="desktop-explanation dynamic-explanation"
					[ngClass]="statusZenplanExplanations ? 'explanationDesktopCollapsed' : '' ">
					<div class="container">
						<div class="closing-help-btn" (click)="statusZenplanExplanations = !statusZenplanExplanations">
							<img alt="closing help button" src="../../assets/img/{{themeService.theme}}/close-btn1.svg">
						</div>
						<img src="../../assets/img/{{themeService.theme}}/how-works.svg" alt="Section Logo"
							width="170px">
						<div class="title">What is a Zenplan?</div>
						<p>
							In case you are not familiar with Zenplans, we help people to easily organise their life’s
							important information in one secure place.
						</p>
						<p>
							People can share their Zenplan with family, friends and advisors so that they can access
							everything they need, when they need it most.
						</p>
					</div>
				</div>

				<div class="mobile-explanation dynamic-explanation"
					[ngClass]="statusZenplanExplanations ? 'explanationMobileCollapsed' : '' ">
					<div class="container">
						<div class="closing-help-btn" (click)="statusZenplanExplanations = !statusZenplanExplanations">
							<img alt="closing help button" src="../../assets/img/{{themeService.theme}}/close-btn1.svg">
						</div>
						<app-delegate-home-mobile-explanation></app-delegate-home-mobile-explanation>
					</div>
				</div>
			</ng-container>
		</section>
		<div *ngIf="user" class="section-title">Welcome {{user.firstName}},</div>
		<div class="welcome-container">
			<div class="content">
				<p>You’ve been made a delegate of <br> someone’s Zenplan - congratulations!</p>
				<p>Provide them with peace of mind that <br> you can easily access everything <br> important when you
					need it most.</p>
			</div>
			<div class="explanations-container">
				<div class="delegate-discover" (click)="statusDelegateExplanation()">
					<img src="../../assets/img/{{themeService.theme}}/delegate.svg" alt="" width="80px">
					<div class="title">What is a Delegate?</div>
					<input type="button" value="Discover" class="btn btn-primary">
				</div>
				<div class="delegate-discover" (click)="statusZenplanExplanation()">
					<img src="../../assets/img/{{themeService.theme}}/delegate.svg" alt="" width="80px">
					<div class="title">What is a Zenplan?</div>
					<input type="button" value="Discover" class="btn btn-primary">
				</div>
			</div>
		</div>
		<!-- For later -->
		<section class="dynamic-collapse">
			<section class="dynamic-collapse-header-toggle"
				[ngClass]="statusMessages ? 'dynamic-collapse-header-collapsed' : ''"
				(click)="statusMessages=!statusMessages">
				<div class="title-label">
					<h3 class="title-section">Your Messages <span class="label">{{totalUnreadMessages}}</span></h3>
				</div>
				<div>
					<img class="minimize-svg" src="../../assets/img/default/top-arrow.svg"
						[ngClass]="statusMessages ? 'minimize-collapsed' : ''" alt="">
				</div>
				<div *ngIf="displayUnreadMessageBadge" class="unread-messages"></div>
			</section>
			<section class="dynamic-collapse-main">
				<section class="dynamic-collapse-content"
					[ngClass]="statusMessages ? 'dynamic-collapse-content-collapsed' : ''">
					<ng-container *ngIf="user && user.Id">
						<app-chat-box [userId]="user.Id" (unreadMessagesEvent)="handleUnreadMessages($event)" (groupedMessagesLengthChange)="onGroupedMessagesLengthChange($event)" class="chat-box"></app-chat-box>
					</ng-container>
				</section>
			</section>
		</section>
	</section>
</section>